import { Box, Divider, Stack, Typography } from '@mui/material';
import { Task } from '@trnsact/trnsact-shared-types';
import { S3_BUCKET_NAME } from "../../../../config";


export const DealerInfo = ({
  task,
  publicAccount,
  commonClasses,
}: {
  task: Task;
  publicAccount: any;
  commonClasses: any,
}) => {

  return <Box className={commonClasses.lenderDealerContactInfoBlock} sx={{ mt: 3 }}>
    <Stack className={commonClasses.infoRows} spacing={1} divider={<Divider />}>
      <Box className={commonClasses.infoRow}>
        <Typography fontWeight={500}>Equipment Supplier</Typography>
        <Typography fontWeight={500}>{publicAccount.name}</Typography>
      </Box>
      <Box className={commonClasses.infoRow}>
        <Typography>Contact</Typography>
        <Typography>{task.createdByUserProfile?.fullName}</Typography>
      </Box>
      <Box className={commonClasses.infoRow}>
        <Typography>Phone</Typography>
        <Typography>{task.createdByUserProfile?.phoneNumber}</Typography>
      </Box>
      <Box className={commonClasses.infoRow}>
        <Typography>Email</Typography>
        <Typography>{task.createdByUserProfile?.email}</Typography>
      </Box>
    </Stack>
    {publicAccount.vendorProfile?.logo && <Box className={commonClasses.logoContainer}>
      <img
        style={{ maxWidth: '100%' }}
        src={`https://${S3_BUCKET_NAME}.s3-us-west-2.amazonaws.com/${publicAccount.vendorProfile.logo}`}
        alt="Dealer Logo"
      />
    </Box>}
  </Box>
};
